export default __webpack_public_path__ + "static/media/TOG.20bbe973.svg";